import "./loading.less";
import {useMessages} from "../language/language";
import {classNames, textOr} from "utils/helpers";
import {CSSProperties, PropsWithChildren } from "react";

export default function Loading(props: PropsWithChildren<{
  className?: string
  isLoading: boolean,
  loadingMessage?: string
  style?: CSSProperties
}>)
{
  const { isLoading, className, style, children,  } = props;
  const msg = useMessages()
  const loadingMessage = textOr(props.loadingMessage, msg.loading)

  if (isLoading) {
    return <div 
      className={classNames('loading-component-container', className)}
      style={style}
    >
      <div className="loading-component">
        <div className="loading-animation"></div>
        <div className="loading-text">
          {loadingMessage}
        </div>
      </div>
     
    </div>
  } else {
    return <>{children}</>
  }
}